export type MediaItemType = 'container' | 'item';
export type MediaType = MediaItemType | 'channel';

const MEDIA_BADGE_LABELS: Record<MediaItemType, string> = {
    item: 'Фильм',
    container: 'сериал'
};

const isMediaType = (value?: string): value is MediaType => {
    return value === 'channel' || value === 'container' || value === 'item';
};

export const getMediaEntity = <T = any>(media?: T): any => {
    return media && typeof media === 'object' && 'item' in (media as Record<string, unknown>) ? media.item : media;
};

export const getRootContainerId = (media?: any): number | string | undefined => {
    const entity = getMediaEntity(media);

    if (entity?.container?.id) {
        return entity.container.parentId || entity.container.id;
    }

    if (entity?.parentId) {
        return entity.parentId;
    }

    return undefined;
};

export const getMediaType = (media?: any, explicitType?: string): MediaType | undefined => {
    const entity = getMediaEntity(media);
    const resolvedType = isMediaType(explicitType) ? explicitType : isMediaType(media?.type) ? media.type : undefined;

    if (resolvedType === 'channel') {
        return 'channel';
    }

    if (resolvedType === 'container') {
        return 'container';
    }

    if (entity?.container?.id) {
        return 'container';
    }

    if (resolvedType === 'item' || entity?.id) {
        return 'item';
    }

    return undefined;
};

export const getMediaDetailType = (media?: any, explicitType?: string): MediaItemType => {
    return getMediaType(media, explicitType) === 'container' ? 'container' : 'item';
};

export const isMediaSerial = (media?: any, explicitType?: string): boolean => {
    return getMediaDetailType(media, explicitType) === 'container';
};

export const getMediaBadgeLabel = (media?: any, explicitType?: string): string | undefined => {
    const mediaType = getMediaType(media, explicitType);

    if (mediaType === 'item' || mediaType === 'container') {
        return MEDIA_BADGE_LABELS[mediaType];
    }

    return undefined;
};
